import React, { useEffect, useState } from 'react'
import { Container, Top } from '../../Admin/styles'
import { DefaultUserPage } from '../../DefaultPages'

import {
  InsideFooter,
  Button,
  Table,
  BoxContainer,
  Breadcrumbs
} from '../../../components'
import PaymentsFilters from './PaymentsFilters'
import RowItem from '../../../components/Table/RowItem'
import HeaderItem from '../../../components/Table/HeaderItem'
import { TooltipButton, TooltipMenu } from '../../../components/Tooltip'
import { HiDotsHorizontal } from 'react-icons/hi'
import SecondBill from '../../../assets/Icons/SecondBill'
import { CursorPointerLink } from './styles'
import { PaginationOrder } from '../../../constants/pagination'
import LocalStorageService from '../../../services/LocalStorageService'
import ecbrApi from '../../../services/ecbrApi'
import { useInfinitePagination } from '../../../hooks/useInfinitePagination'
import { openLinkOfPDFInANewBrowserTab } from '../../../helpers/openPDFOnBrowser'
import { dateTypes } from '../../../constants/date'
import { PaymentMethodTextForList } from '../../../constants/order'
import { formatCentsToReal } from '../../../helpers/formatCentsToReal'
import dayjs from '../../../helpers/dayjs'

const pagination = { page: 1, take: 10 }

const Payments = () => {
  const user = LocalStorageService.get('user') || {}
  const [company] = user.companies || []
  const [error, setError] = useState('')
  const [searchParameters, setSearchParameters] = useState({
    ...pagination,
    order: PaginationOrder.ASC,
    companyId: company.id
  })

  const {
    data: invoices,
    fetchNextPage,
    hasNextPage,
    isLastPage,
    isFetching,
    isLoading,
    refetch
  } = useInfinitePagination(
    'invoices',
    async (params) => {
      const { pageParam = searchParameters.page } = params
      return ecbrApi.invoices.getActualCompanyInvoices({
        ...searchParameters,
        page: pageParam || searchParameters.page
      })
    },
    {
      enabled:
        searchParameters.companyId !== null &&
        searchParameters.brandId !== null,
      onSuccess: () => {
        setError('')
      },
      onError: () => {
        setError('Não foi possível carregar os dados')
      }
    }
  )

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParameters])

  return (
    <DefaultUserPage page="payments">
      <Container>
        <Top>
          <Breadcrumbs />
        </Top>
        <h3>Veja o histórico de pagamentos de todas as suas empresas</h3>

        <PaymentsFilters
          setFilters={(filters) =>
            setSearchParameters({
              ...pagination,
              order: PaginationOrder.ASC,
              companyId: company.id,
              ...filters
            })
          }
        />
        <BoxContainer>
          {error && <p>{error}</p>}
          {!error && (
            <Table templateColumns="11% 14% 15% 12% 10% 5% 9% 6% 5% 5%">
              <header>
                <ul>
                  <HeaderItem>Identificação</HeaderItem>
                  <HeaderItem>Empresa</HeaderItem>
                  <HeaderItem>Certificação</HeaderItem>
                  <HeaderItem>Valor</HeaderItem>
                  <HeaderItem>Tipo</HeaderItem>
                  <HeaderItem>Parcelas</HeaderItem>
                  <HeaderItem>Data</HeaderItem>
                  <HeaderItem>Status</HeaderItem>
                  <HeaderItem>2ª via</HeaderItem>
                  <HeaderItem>Ações</HeaderItem>
                </ul>
              </header>
              <main>
                {invoices?.map?.((invoice) => (
                  <ul key={invoice.id}>
                    <RowItem>#{invoice.codeGateway}</RowItem>
                    <RowItem>{invoice.products[0].name}</RowItem>
                    <RowItem>{invoice.products[0].description}</RowItem>
                    <RowItem>{formatCentsToReal(invoice.amount)}</RowItem>
                    <RowItem>
                      {PaymentMethodTextForList[invoice.paymentMethod]}
                    </RowItem>
                    <RowItem>
                      {invoice.installments ? invoice.installments : '1'}x
                    </RowItem>
                    <RowItem>
                      {dayjs(invoice.createdAt).format(dateTypes.dateBR)}
                    </RowItem>
                    <RowItem>
                      {invoice.status === 'paid' ? 'Pago' : 'Pendente'}
                    </RowItem>
                    <RowItem>
                      {invoice.paymentMethod === 'boleto' ? (
                        <CursorPointerLink
                          onClick={() =>
                            openLinkOfPDFInANewBrowserTab(invoice.pdf)
                          }
                        >
                          <SecondBill />
                        </CursorPointerLink>
                      ) : (
                        '-'
                      )}
                    </RowItem>
                    <RowItem>
                      {invoice.paymentMethod === 'boleto' ? (
                        <TooltipMenu
                          icon={<HiDotsHorizontal />}
                          name="userOptions"
                          closeOnClick
                        >
                          <TooltipButton
                            text="Emitir segunda via"
                            onClick={() =>
                              openLinkOfPDFInANewBrowserTab(invoice.pdf)
                            }
                          />
                        </TooltipMenu>
                      ) : (
                        '-'
                      )}
                    </RowItem>
                  </ul>
                ))}
              </main>
              <footer>
                {hasNextPage && !isLastPage && (
                  <Button
                    type="button"
                    variant="outlined"
                    text={
                      isLoading || isFetching ? 'Carregando...' : 'Ver mais'
                    }
                    width="200px"
                    height="40px"
                    onClick={fetchNextPage}
                  />
                )}
              </footer>
            </Table>
          )}
        </BoxContainer>
        <InsideFooter />
      </Container>
    </DefaultUserPage>
  )
}

export default Payments
